import type { I18nOptions } from "vue-i18n"
import type { RecursiveKeyOf } from "@/types/utils"
import { getNavigatorLanguage } from "@/utils"
import * as locales from "./locales"

export type LocaleCodes = keyof typeof locales
export type MessageSchema = (typeof locales)[LocaleCodes]
export type I18nString = RecursiveKeyOf<MessageSchema>

export function getI18NConf() {
	const localesEntries = Object.entries<MessageSchema>(locales)

	const messages = localesEntries.reduce((acc: { [key: string]: MessageSchema }, cur: [string, MessageSchema]) => {
		acc[cur[0]] = cur[1]
		return acc
	}, {}) as { [key in LocaleCodes]: MessageSchema }

	const localeCode = getNavigatorLanguage()

	return {
		legacy: false,
		locale: localeCode,
		fallbackLocale: "it",
		messages,
		warnHtmlMessage: false
	} satisfies I18nOptions
}
